import { extractKeysFromDicitionary } from './extract-keys-from-dictionary';

export const getCustomTocTitles = (dict: Localisation.CsvFileContent) =>
  extractKeysFromDicitionary(dict, '#slide|');
